import { createComponent } from '@carvana/merch-components';
import { EvGuideSection } from '../../styles';

export const SectionWrapper = createComponent(EvGuideSection, {
  className:
    'grid !max-w-full gap-7xl bg-canvas-muted md:grid-cols-[minmax(475px,1fr)_minmax(0,624px)] lg:!px-[84px]'
});

export const IconWrapper = createComponent('div', {
  className: `
    absolute
    right-[30px]
    top-[-27px]
    flex
    h-[64px]
    w-[64px]
    items-center
    justify-center
    rounded-[106px]
    bg-decorative-ev
    sm:right-[40px]
    sm:top-[-40px]
    sm:h-[80px]
    sm:w-[80px]
    md:top-[-62px]
    md:h-[124px]
    md:w-[124px]
  `
});

export const ImageWrapper = createComponent('div', {
  className:
    'relative my-2xl h-[245px] w-full sm:my-4xl sm:h-[528px] md:my-auto'
});

export const IconImg = createComponent('img', {
  className: 'h-[33px] w-[24px] sm:h-[41px] sm:w-[31px] md:h-[64px] md:w-[47px]'
});

export const SectionImg = createComponent('img', {
  className: 'h-full w-full rounded-2xl object-cover'
});

export const ContentWrapper = createComponent('div', {
  className: 'flex flex-col gap-md'
});
